import { modalTypes } from "constants/types";
import { hideModal, showModal } from "slices/app/actions/modals";
import { getErrorMessage, refreshPage } from "utils";

export const showMissingDocumentModal = () => (dispatch) => {
  dispatch(
    showModal(modalTypes.CONFIRMATION, {
      headerText: "Document Not Available",
      bodyText:
        "The document has been deleted and is no longer available. Please refresh and select a different document.",
      okButton: {
        text: "Refresh",
        onOk: () => {
          refreshPage();
          dispatch(hideModal(modalTypes.CONFIRMATION));
        },
      },
    })
  );
};

export const showErrorModal = (error, title) => (dispatch) => {
  // AUP acceptance is surfaced by the axios interceptor via its own modal;
  // suppress the generic ERROR modal so it doesn't stack on top.
  if (
    error?.response?.status === 403 &&
    error?.response?.data?.errorCode === "AUP_ACCEPTANCE_REQUIRED"
  ) {
    return;
  }
  dispatch(
    showModal(modalTypes.ERROR, {
      errorMessage: getErrorMessage(error),
      title,
      handleOk: hideModal(modalTypes.ERROR),
    })
  );
};

export const validateErrorResponse = (error) => (dispatch) => {
  const lockedItems = error?.response?.data?.lockedItems;

  if (error?.response?.status === 423 && lockedItems) {
    dispatch(
      showModal(modalTypes.LOCKED_ITEMS_MODAL, {
        lockedItems,
        handleOk: hideModal(modalTypes.LOCKED_ITEMS_MODAL),
      })
    );
  } else {
    dispatch(showErrorModal(error));
  }
};
